import APP_CONSTANTS from "../constants";

const apiRoute = APP_CONSTANTS.apiUrl + "/api/v4";

// export const getStateListApiRoute = `${apiRoute}/getStateList`; // done in backend-upgrade
export const getConstansApiRoute = `${apiRoute}/constants`; // done in backend-upgrade
export const exportDataApiRoute = `${apiRoute}/admin/exportData`; // done in backend-upgrade
export const exportRequestLogsApiRoute = `${apiRoute}/admin/patient/requestLogs`; // done in backend-upgrade
export const blockedDoctorsApiRoute = `${apiRoute}/admin/getBlockedDoctors`; // ! NOT USING IT ANYMORE
// export const updateConstantsApiRoute = `${apiRoute}/constants/updateConstants`; //? Replaced with /admin/constants/update
export const updateConstantsApiRoute = `${apiRoute}/admin/constants/update`; // done in backend-upgrade

export const appSettingsApiRoute = `${apiRoute}/admin/appSetting`;

export const sendNotificationsApiRoute = `${apiRoute}/admin/sendNotifications`; // done in backend-upgrade
export const sendNotificationsPatientApiRoute = `${apiRoute}/admin/sendNotificationsPatient`; // ! I HAVE COMBINED 2 APIS INTO ONE

// auth
export const loginApiRoute = `${apiRoute}/admin/loginAdmin`; // done in backend-upgrade
export const forgotPasswordApiRoute = `${apiRoute}/admin/forgotPassword`; // done in backend-upgrade
export const changePasswordApiRoute = `${apiRoute}/admin/changePassword`; // done in backend-upgrade
export const verifyLinkApiRoute = `${apiRoute}/admin/verifyLink?pwd_tkn=`; // done in backend-upgrade
export const updatePasswordApiRoute = `${apiRoute}/admin/updatePassword`; // done in backend-upgrade
export const changePinApiRoute = `${apiRoute}/admin/changePin`; // done in backend-upgrade

//search api's
export const searchDoctorsApiRoute = `${apiRoute}/admin/searchDoctor`; // done in backend-upgrade
export const searchPatientsApiRoute = `${apiRoute}/pms/searchPatients`; // done in backend-upgrade

// ticket
export const getTicketsWithFilterApiRoute = `${apiRoute}/admin/getTicketsWithFilter`; // done in backend-upgrade
export const getTicketsApiRoute = `${apiRoute}/admin/getTickets`; // done in backend-upgrade
export const exportTicketsApiRoute = `${apiRoute}/admin/exportAllTickets`; // done in backend-upgrade
export const getTicketByIdApiRoute = `${apiRoute}/admin/getTicketById`; // done in backend-upgrade
export const deleteTicketApiRoute = `${apiRoute}/admin/deleteTicket/`; // done in backend-upgrade
export const editTicketApiRoute = `${apiRoute}/admin/editTicket/`; // done in backend-upgrade
export const addTicketApiRoute = `${apiRoute}/admin/createTicket`; // done in backend-upgrade
export const addRequestedTestApiRoute = `${apiRoute}/admin/ticket/addRequestedTest`;
export const getReceivedResultsApiRoute = `${apiRoute}/ai/tickets/get-patient-results-for-admin-approval`;
export const deleteReceivedResultApiRoute = `${apiRoute}/ai/tickets/delete-patient-results-for-admin-approval`;
export const approveReceivedResultApiRoute = `${apiRoute}/ai/tickets/approve-patient-results-by-mapping`;
export const readS3FileBufferApiRoute = `${apiRoute}/admin/read/s3-file-buffer`;
export const mergeTicketDocumentsApiRoute = `${apiRoute}/admin/merge-ticket-documents`;
export const attachTicketDocumentToConsultNoteApiRoute = `${apiRoute}/admin/attach-ticket-document-to-consult-note`;
// export const getPathologyRequestTemplateAPI = `${apiRoute}/pms/getPathologyRequestTemplates`; // done in backend-upgrade  //! NOT TESTED YET
// export const deletePathologyRequestTemplateAPI = `${apiRoute}/pms/deletePathologyRequestTemplate`; // done in backend-upgrade  //! NOT TESTED YET
// export const addPathologyRequestTemplateAPI = `${apiRoute}/pms/addPathologyRequestTemplate`; // done in backend-upgrade  //! NOT TESTED YET

// staff
export const getSupportStaffApiRoute = `${apiRoute}/admin/getSupportStaff`; // done in backend-upgrade
export const deleteStaffApiRoute = `${apiRoute}/admin/deleteStaff/`; // done in backend-upgrade
export const blockUnblockStaffApiRoute = `${apiRoute}/admin/blockUnblock/`; // done in backend-upgrade
export const editSupportStaffApiRoute = `${apiRoute}/admin/editSupportStaff/`; // done in backend-upgrade
export const addSupportStaffApiRoute = `${apiRoute}/admin/addSupportStaff`; // done in backend-upgrade

// Patient
export const resetPatientPassword = `${apiRoute}/admin/patient/resetPassword`; // done in backend-upgrade
export const cancelBookingApiRoute = `${apiRoute}/admin/cancel/booking`
export const getPatientListApiRoute = `${apiRoute}/admin/getPatientList`; // done in backend-upgrade
export const getPatientListWithFiltersApiRoute = `${apiRoute}/admin/getPatientListWithFilter`; // done in backend-upgrade
export const blockPatientApiRoute = `${apiRoute}/admin/blockPatient`; // done in backend-upgrade
export const deletePatientApiRoute = `${apiRoute}/admin/deletePatient/`; // done in backend-upgrade
export const sendPatNotificationApiRoute = `${apiRoute}/admin/sendNotifications`; // done in backend-upgrade
export const editPatProfileApiRoute = `${apiRoute}/admin/editPatientProfile`; // done in backend-upgrade //! not tested yet
// export const getPatientsQueueApiRoute = `${apiRoute}/admin/getPatientsQueueV2`; //? replaced with getPatientsQueue
export const getBookingsApiRoute = `${apiRoute}/admin/bookings`; // done in backend-upgrade
export const getConsultRequestsApiRoute = `${apiRoute}/admin/appointments`; // done in backend-upgrade
export const getPatientsQueueApiRoute = `${apiRoute}/admin/getPatientsQueue`; // done in backend-upgrade
export const removePatientFromQueueApiRoute = `${apiRoute}/admin/removePatientFromQueue`; // done in backend-upgrade
export const verifyPatientByMedicareOnlineApiRoute = `${apiRoute}/admin/verifyPatientByMedicareOnline`; // done in backend-upgrade - need to double check though
export const removeCancelFlag = `${apiRoute}/admin/remove-cancel-flag`; // remove cancel flag after doctor cancels patient's request

export const checkIfMedicareCardDuplicateExistsApiRoute = `${apiRoute}/patient/checkIfMedicareCardDuplicateExists`; // done in backend-upgrade

export const updateAppointmentStatusReasonApiRoute = `${apiRoute}/admin/updateAppointmentStatusReason`; // done in backend-upgrade

export const removePatientEntryFromQueueApiRoute = `${apiRoute}/admin/removePatientEntryFromQueue`; // done in backend-upgrade

// Doctor
// export const getDoctorListApiRoute = `${apiRoute}/admin/getDoctorList`; //? replaced with admin/doctors/approved
// export const getPendingDoctorListApiRoute = `${apiRoute}/admin/getPendingDoctorList`; //? replaced with admin/doctors/pending
// export const getRejectedDoctorListApiRoute = `${apiRoute}/admin/getRejectedDoctorList`; //? replaced with admin/doctors/rejected
// export const acceptedDoctorApiRoute = `${apiRoute}/admin/acceptedDoctor`;
// export const rejectedDoctorApiRoute = `${apiRoute}/admin/rejectedDoctor`; //? replaced with admin/doctor/reject
// export const blockDoctorApiRoute = `${apiRoute}/admin/blockDoctor`; //? replaced with admin/doctor/block/status
// export const deleteDoctorApiRoute = `${apiRoute}/admin/deleteDoctor/`; //? replaced with admin/doctor/pending/:doctorId
// export const moveToPendingApiRoute = `${apiRoute}/admin/moveToPending`; //? replaced with admin/doctor/pending/
// export const removeDoctorApplicationApiRoute = `${apiRoute}/admin/removeDoctorApplication`; //? replaced with admin/doctor/application - DELETE TYPE
// export const changeBusyModeAdminApiRoute = `${apiRoute}/doctor/changeBusyModeAdmin`; //? replaced with /doctor/changeBusyMode - we are using the same api for doctors as well with little difference
export const getListOfPatientsWhoBlockedApiRoute = `${apiRoute}/admin/getListOfPatientsWhoBlocked`; // ! not using any more
export const getDoctorListApiRoute = `${apiRoute}/admin/doctors/approved`; // done in backend-upgrade
export const getPendingDoctorListApiRoute = `${apiRoute}/admin/doctors/pending`; // done in backend-upgrade
export const getRejectedDoctorListApiRoute = `${apiRoute}/admin/doctors/rejected`; // done in backend-upgrade
export const acceptedDoctorApiRoute = `${apiRoute}/admin/doctor/approve`; // done in backend-upgrade
export const rejectedDoctorApiRoute = `${apiRoute}/admin/doctor/reject`; // done in backend-upgrade
export const blockDoctorApiRoute = `${apiRoute}/admin/doctor/block/status`; // done in backend-upgrade
export const deleteDoctorApiRoute = `${apiRoute}/admin/doctor/pending/`; // done in backend-upgrade
export const removeDoctorApplicationApiRoute = `${apiRoute}/admin/doctor/application`; // done in backend-upgrade
export const deleteDoctorStripeAccountApiRoute = `${apiRoute}/admin/deleteDoctorStripeAccount`; // ! I think it's not needed for new doctors so I'll not develop this API
export const changeBusyModeAdminApiRoute = `${apiRoute}/doctor/changeBusyMode`; // done in backend-upgrade
export const logoutFromAdminApiRoute = `${apiRoute}/doctor/logoutFromAdmin`; // done in backend-upgrade
export const getDoctorBookingsApiRoute = `${apiRoute}/admin/getDoctorBookings`; // done in backend-upgrade
// export const editDoctorProfileApiRoute = `${apiRoute}/admin/editDoctorProfile`; //? replaced with admin/doctor/edit
export const editDoctorProfileApiRoute = `${apiRoute}/admin/doctor/edit`; // done in backend-upgrade

// call
// export const getQueueOfDoctorApiRoute = `${apiRoute}/call/getQueueOfDoctor`;
export const getQueueOfDoctorApiRoute = `${apiRoute}/admin/getQueueOfDoctor`; // done in backend-upgrade
// export const endCallByDoctorFromAdminApiRoute = `${apiRoute}/call/endCallByDoctorFromAdmin`;
export const endCallByDoctorFromAdminApiRoute = `${apiRoute}/admin/call/end`; // done in backend-upgrade

// pharmacies
export const getPharmacyDetailApiRoute = `${apiRoute}/pms/getPharmacyDetail`; // done in backend-upgrade
export const getRecentPrescriptionsApiRoute = `${apiRoute}/pms/getRecentPrescriptions`; // done in backend-upgrade
export const uploadPharmacyDataApiRoute = `${apiRoute}/pms/uploadPharmacyData`; // done in backend-upgrade

// Nature of Consult
export const getConsultsApiRoute = `${apiRoute}/admin/getConsults`; // done in backend-upgrade
export const deleteConsultApiRoute = `${apiRoute}/admin/deleteConsult`; // done in backend-upgrade
export const addNatureConsultApiRoute = `${apiRoute}/admin/addNatureConsult`; // done in backend-upgrade
export const editNatureConsultApiRoute = `${apiRoute}/admin/editNatureConsult`; // done in backend-upgrade
export const changeConsultSequenceApiRoute = `${apiRoute}/admin/changeConsultSequence`; // done in backend-upgrade

// Consult Costs
export const getConsultDetailsApiRoute = `${apiRoute}/admin/getConsultDetails`; // done in backend-upgrade
export const addConsultDetailApiRoute = `${apiRoute}/admin/addConsultDetail`; // done in backend-upgrade
export const editConsultDetailApiRoute = `${apiRoute}/admin/editConsultDetail`; // done in backend-upgrade
export const deleteConsultDetailApiRoute = `${apiRoute}/admin/deleteConsultDetail`; // done in backend-upgrade
export const changeConsultDetailsSequenceApiRoute = `${apiRoute}/admin/changeConsultDetailsSequence`; // done in backend-upgrade
export const changeDefaultConsultCostApiRoute = `${apiRoute}/admin/consultcost/default`; // done in backend-upgrade

export const getConsultDetailsMedicareApiRoute = `${apiRoute}/admin/getConsultDetailsMedicare`; // done in backend-upgrade
export const addConsultDetailMedicareApiRoute = `${apiRoute}/admin/addConsultDetailMedicare`; // done in backend-upgrade
export const editConsultDetailMedicareApiRoute = `${apiRoute}/admin/editConsultDetailMedicare`; // done in backend-upgrade
export const deleteConsultDetailMedicareApiRoute = `${apiRoute}/admin/deleteConsultDetailMedicare`; // done in backend-upgrade
export const changeConsultDetailsMedicareSequenceApiRoute = `${apiRoute}/admin/changeConsultDetailsMedicareSequence`; // done in backend-upgrade

// Consult Costs Instant Switch
export const addInstantSwitchConsultDetailsAPI = `${apiRoute}/admin/addInstantSwitchConsultDetail`; // done in backend-upgrade
export const getInstantSwitchConsultDetailsAPI = `${apiRoute}/admin/getInstantSwitchConsultDetails`; // done in backend-upgrade
export const editInstantSwitchConsultDetailsAPI = `${apiRoute}/admin/editInstantSwitchConsultDetail`; // done in backend-upgrade
export const deleteInstantSwitchConsultDetailAPI = `${apiRoute}/admin/deleteInstantSwitchConsultDetail`; // done in backend-upgrade
export const changeInstantSwitchConsultDetailsSequenceAPI = `${apiRoute}/admin/changeInstantSwitchConsultDetailsSequence`; // done in backend-upgrade

// Consult Costs MBS (Medicare) Instant Switch
export const getInstantSwitchConsultDetailsMedicareAPI = `${apiRoute}/admin/getInstantSwitchConsultDetailsMedicare`; // done in backend-upgrade
export const addInstantSwitchConsultDetailMedicareAPI = `${apiRoute}/admin/addInstantSwitchConsultDetailMedicare`; // done in backend-upgrade
export const editInstantSwitchConsultDetailMedicareAPI = `${apiRoute}/admin/editInstantSwitchConsultDetailMedicare`; // done in backend-upgrade
export const deleteInstantSwitchConsultDetailMedicareAPI = `${apiRoute}/admin/deleteInstantSwitchConsultDetailMedicare`; // done in backend-upgrade
export const changeInstantSwitchConsultDetailsMedicareSequenceAPI = `${apiRoute}/admin/changeInstantSwitchConsultDetailsMedicareSequence`; // done in backend-upgrade

// IC MBS Item API Routes
export const addICMBSItemApiRoute = `${apiRoute}/admin/ic/mbs-item/add`;
export const editICMBSItemApiRoute = `${apiRoute}/admin/ic/mbs-item/edit`;
export const deleteICMBSItemApiRoute = `${apiRoute}/admin/ic/mbs-item/delete`;

export const uploadCovidHotSpotDataApiRoute = `${apiRoute}/admin/uploadCovidHotSpotData`; // done in backend-upgrade

// Consult History
export const sessionsApiRoute = `${apiRoute}/admin/sessions`; // done in backend-upgrade
export const sessionsWithFilterApiRoute = `${apiRoute}/admin/sessionsWithFilter`; // done in backend-upgrade
export const exportConsultHistoryApiRoute = `${apiRoute}/admin/exportConsultHistory`; // done in backend-upgrade // TODO - need to test
export const unansweredCallsApiRoute = `${apiRoute}/admin/unansweredCalls`; // done in backend-upgrade
export const unansweredCallsFilterApiRoute = `${apiRoute}/admin/unansweredCallsFilter`; // done in backend-upgrade
export const exportUnAnsweredConsultHistoryApiRoute = `${apiRoute}/admin/exportUnAnsweredConsultHistory`; // done in backend-upgrade
export const moveToPastConsultsApiRoute = `${apiRoute}/admin/moveToPastConsults`; // done in backend-upgrade // TODO but need to test
export const getSessionByIdApiRoute = `${apiRoute}/admin/getSessionById`; // done in backend-upgrade
export const updateAdminConnReportMarkApiRoute = `${apiRoute}/admin/updateAdminConnReportMark`; // done in backend-upgrade
export const markUnSuccessFulApiRoute = `${apiRoute}/admin/markUnSuccessFul`; // done in backend-upgrade
export const markSuccessFulApiRoute = `${apiRoute}/admin/markSuccessFul`; // done in backend-upgrade
// export const updateConsultCostApiRoute = `${apiRoute}/appointment/updateConsultCost`; //? replaced this API with /admin/appointment/updateConsultCost
export const updateConsultCostApiRoute = `${apiRoute}/admin/appointment/updateConsultCost`; // done in backend-upgrade
export const editConsultDurationApiRoute = `${apiRoute}/admin/editConsultDuration`; // done in backend-upgrade
export const changeDoctorApiRoute = `${apiRoute}/admin/consult/changeDoctor`; // done in backend-upgrade
export const changePatientApiRoute = `${apiRoute}/admin/pastconsult/change-patient`;
export const addBulkBilledIncentiveApiRoute = `${apiRoute}/doctor/appointment/addBulkBilledIncentive`;

export const exportMedicareConsultHistoryApiRoute = `${apiRoute}/admin/exportMedicareConsultHistory`; // done in backend-upgrade
export const checkIfMedicareEclaimAlreadyExportedApiRoute = `${apiRoute}/admin/checkIfMedicareEclaimAlreadyExported`; // done in backend-upgrade
export const checkIfConsultMedicareClaimedAlreadyLoggedApiRoute = `${apiRoute}/admin/checkIfConsultMedicareClaimedAlreadyLogged`; // done in backend-upgrade

// Faq
export const faqApiRoute = `${apiRoute}/admin/faq`; // done in backend-upgrade //? There are 3 different APIs for Create/Update/Delete within this API

// Support chat
export const getChats = `${apiRoute}/admin/getChats`; // done in backend-upgrade
export const getChatMsg = `${apiRoute}/admin/getChatMessages`; // done in backend-upgrade
export const uploadChatFile = `${apiRoute}/admin/uploadChatFiles`; // done in backend-upgrade
export const clearChatData = `${apiRoute}/admin/clearchat`; // done in backend-upgrade
export const deleteAllChatMessage = `${apiRoute}/admin/deleteAllChatMessage`; // done in backend-upgrade
export const doctorListForChat = `${apiRoute}/admin/getDoctorAndNurseList`; // done in backend-upgrade

// PRODA and MedicareOnline API
export const activePRODADeviceApiRoute = `${apiRoute}/admin/activePRODADevice`; // done in backend-upgrade

// MIMS API
export const accessMIMSTokenApiRoute = `${apiRoute}/pms/accessMIMSToken`; // done in backend-upgrade
export const rotateMIMSKeysApiRoute = `${apiRoute}/mims/v3/rotate-keys`;
export const getProductsByIngredientApiRoute = `${apiRoute}/pms/getProductsByIngredient`; // done in backend-upgrade
export const getProductsByBrandApiRoute = `${apiRoute}/pms/getProductsByBrand`; // done in backend-upgrade
export const getDrugProductDetailsByIdApiRoute = `${apiRoute}/pms/getDrugProductDetailsById`; // done in backend-upgrade
export const getDrugPBSDetailsByPBSCodeApiRoute = `${apiRoute}/pms/getDrugPBSDetailsByPBSCode`; // done in backend-upgrade
export const getBlockedDrugsApiRoute = `${apiRoute}/mims/v3/blocked-drugs-and-products`;
export const saveBlockedDrugsApiRoute = `${apiRoute}/mims/v3/blocked-drugs-and-products`;
export const getScheduleConfigurationApiRoute = `${apiRoute}/mims/v3/schedule-configuration`;
export const updateScheduleConfigurationApiRoute = `${apiRoute}/mims/v3/update/schedule-configuration`;

// Coupons
// export const getCouponListApiRoute = `${apiRoute}/admin/getCouponList`;
export const getCouponListApiRoute = `${apiRoute}/admin/coupons`; // done in backend-upgrade //! There was a complicated logic in v3 backend code. Not sure why they did that
export const addNewCouponApiRoute = `${apiRoute}/admin/addNewCoupon`; // done in backend-upgrade
export const editCouponApiRoute = `${apiRoute}/admin/editCoupon`; // done in backend-upgrade
export const updateCouponStatusApiRoute = `${apiRoute}/admin/updateCouponStatus`; // done in backend-upgrade
export const deleteCouponApiRoute = `${apiRoute}/admin/deleteCoupon`; // done in backend-upgrade
export const getCouponDetailsApiRoute = `${apiRoute}/admin/getCouponDetails`; // done in backend-upgrade

// ABA File Export
export const exportAbaFileConsultHistoryApiRoute = `${apiRoute}/admin/exportAbaFileConsultHistory`; // done in backend-upgrade
// export const checkIfAbaFileAlreadyExportedApiRoute = `${apiRoute}/admin/checkIfAbaFileAlreadyExportedApiRoute`; //? replaced with /admin/checkIfAbaFileAlreadyExported
export const checkIfAbaFileAlreadyExportedApiRoute = `${apiRoute}/admin/checkIfAbaFileAlreadyExported`; // done in backend-upgrade

// Forum
export const markAllPostsReadApiRoute = `${apiRoute}/forum/post/read/comments/all`; // done in backend-upgrade
export const getPostsListApiRoute = `${apiRoute}/forum/getPostsList`; // done in backend-upgrade
export const addForumPostApiRoute = `${apiRoute}/forum/addForumPost`; // done in backend-upgrade
export const deleteForumPostApiRoute = `${apiRoute}/forum/deleteForumPost`; // done in backend-upgrade

export const getPostDetailsApiRoute = `${apiRoute}/forum/getPostDetails`; // done in backend-upgrade
export const getPostCommentsApiRoute = `${apiRoute}/forum/getPostComments`; // done in backend-upgrade
export const addPostCommentApiRoute = `${apiRoute}/forum/addPostComment`; // done in backend-upgarde
export const updatePostCommentApiRoute = `${apiRoute}/forum/updatePostComment`; // done in backend-upgrade
export const deletePostCommentApiRoute = `${apiRoute}/forum/deletePostComment`; // done in backend-upgrade
export const addPostCommentReplyApiRoute = `${apiRoute}/forum/addPostCommentReply`; // done in backend-upgrade
export const updatePostCommentReplyApiRoute = `${apiRoute}/forum/updatePostCommentReply`; // done in backend-upgrade
export const deletePostCommentReplyApiRoute = `${apiRoute}/forum/deletePostCommentReply`; // done in backend-upgrade

export const getUnreadForumPostCount = `${apiRoute}/forum/getUnreadForumPosts`; // done in backend-upgrade
export const readForumPostsAPI = `${apiRoute}/forum/readAllForumPosts`; // done in backend-upgrade
export const updateForumCommentCount = `${apiRoute}/forum/post/read/comments`;

// Doctor Monthly Summary
export const getPaymentSummariesListNew = `${apiRoute}/admin/getPaymentSummarynew`; // done in backend-upgrade // used for monthly summary :  need to pass ?endDate=2019-01-31T23:59:00.000Z&startDate=2019-01-01T00:00:00.000Z

export const getMonthlyConsultApi = `${apiRoute}/admin/exportMonthlyConsultOfDoctor`; // done in backend-upgrade

export const getDbFormsApi = `${apiRoute}/admin/downloaddb4forms`; // done in backend-upgrade

// Send Ticket notification to doctors
export const sendDoctorTicketNotificationAPI = `${apiRoute}/admin/addDoctorTicketNotification`; // done in backend-upgrade

// get logs
export const getLogFileApiRoute = `${apiRoute}/admin/getLogFile`; // ! Need to ask Leo about this as this code is commented on Front-end and backend

// HI API
export const requestHIServiceSearchIHIApiRoute = `${apiRoute}/admin/requestHIServiceSearchIHI`; // done in backend-upgrade
export const getIHIHistoryRecordApiRoute = `${apiRoute}/admin/getIHIHistoryRecord`; // done in backend-upgrade
export const checkIsDuplicateIHINumberApiRoute = `${apiRoute}/admin/checkIsDuplicateIHINumber`; // done in backend-upgrade
export const checkDuplicatePatientDemographicInfoApiRoute = `${apiRoute}/admin/checkDuplicatePatientDemographicInfo`; // done in backend-upgrade
export const requestHIServiceSearchHPIIApiRoute = `${apiRoute}/admin/requestHIServiceSearchHPII`; // done in backend-upgrade
export const checkDuplicateDoctorDemographicInfoApiRoute = `${apiRoute}/admin/checkDuplicateDoctorDemographicInfo`; // done in backend-upgrade
export const checkIsDuplicateHPIINumberApiRoute = `${apiRoute}/admin/checkIsDuplicateHPIINumber`; // done in backend-upgrade
export const getHPIIHistoryRecordApiRoute = `${apiRoute}/admin/getHPIIHistoryRecord`; // done in backend-upgrade

//temp use, SOAP log export
// export const tempSOAPLog = `${apiRoute}/admin/tempSOAPLog`;

// set Password Config
export const setPasswordConfigApiRoute = `${apiRoute}/admin/setPasswordConfig`; // ! Need to ask Leo about this as this code is commented on Front-end and backend


// marketing file upload
export const marketingFileUpload = `${apiRoute}/admin/uploadMarketingImage`; // done in backend-upgrade
export const promotionSendAPI = `${apiRoute}/admin/sendPromotionEmail`; // done in backend-upgrade
export const promotionEmailListAPI = `${apiRoute}/admin/getPromotionalEmails`; // done in backend-upgrade
export const marketingPatientExportListAPI = `${apiRoute}/admin/marketing/export`;

export const uploadMedicareConsultNoteCSVApiRoute = `${apiRoute}/admin/uploadconsultnotecsv`; // done in backend-upgrade but not tested yet

// **************** Action ERX Offline / Action Invalid IHI *****************

// get traditional prescription list
export const getTraditionalPrescriptionListAPI = `${apiRoute}/admin/traditionalprescriptions`; // done in backend-upgrade

// get traditional prescription list with filters
export const getTraditionalPrescriptionListWithFilterAPI = `${apiRoute}/admin/traditionalprescription/filter`; // done in backend-upgrade

// update traditional prescription other data (status/pharmacistName)
export const updateTraditionalPrescriptionConsultNote = `${apiRoute}/admin/traditionalprescription/update`; // done in backend-upgrade

// hide traditional prescription from admin table only
export const hideTraditionalPrescriptionFromAdminAPI = `${apiRoute}/admin/traditionalprescription/hide`; // done in backend-upgrade

export const countAppointmentsAPI = `${apiRoute}/admin/count/appointments`;

export const generateEPrescribingApiRoute = `${apiRoute}/pms/generateEPrescribing`;

export const sendCustomNoteApiRoute = `${apiRoute}/pms/SendCustomNote`;

// ************* Instant Switch APIs ***************



//Instant Switch
export const getOrderHistoryAPI = `${apiRoute}/is/orderhistory`; // done in backend-upgrade
// export const getOrderHistoryWithFilterAPI = `${apiRoute}/admin/orderHistoryWithFilter`; //? replaced with /is/orderHistoryWithFilter
export const getOrderHistoryWithFilterAPI = `${apiRoute}/is/orderHistoryWithFilter`; // done in backend-upgrade

// change status of online assessment for Instant Switch
// export const changeOnlineAssessmentStatusAPI = `${apiRoute}/admin/changeOnlineAssessmentStatus`; //? replaced with /is/changeOnlineAssessmentStatus
export const changeOnlineAssessmentStatusAPI = `${apiRoute}/is/changeOnlineAssessmentStatus`; // done in backend-upgrade

// toggle isRequire support for Instant Switch
// export const toggleIsRequireSupportISAPI = `${apiRoute}/admin/instantswitch/onlineassessment/support/status`; //? replaced with is/onlineassessment/support/status
export const toggleIsRequireSupportISAPI = `${apiRoute}/is/onlineassessment/support/status`; // done in backend-upgrade

// delete online assessment API - Instant Switch
// export const deleteOnlineAssessmentAPI = `${apiRoute}/admin/deleteAssessmentOrder`; //? replaced with is/deleteAssessmentOrder
export const deleteOnlineAssessmentAPI = `${apiRoute}/is/deleteAssessmentOrder`; // done in backend-upgrade

// instant switch - export online assessments
// export const exportOnlineAssessmentCSVAPI = `${apiRoute}/admin/exportOnlineAssessments`;
export const exportOnlineAssessmentCSVAPI = `${apiRoute}/is/exportOnlineAssessments`; // done in backend-upgrade

// instant swtich - change consult cost
// export const updateConsultCostInstantSwitchAPI = `${apiRoute}/instantswitch/updateConsultCostIS`; //? Replaced with /is/updateConsultCost
export const updateConsultCostInstantSwitchAPI = `${apiRoute}/is/updateConsultCost`; // done in backend-upgrade

// instant switch - change patient contact time
// export const updateDoctorContactByTimeAPI = `${apiRoute}/admin/instantswitch/onlineassessment/change/contact`; //? Replaced with /is/onlineassessment/change/contact
export const updateDoctorContactByTimeAPI = `${apiRoute}/is/onlineassessment/change/contact`; // done in backend-upgrade

// instant switch - send notification to patient - for now we just send email but SMS code is already there if you want to use it - now we are sending SMS as well but same account from Instant Consult
// export const sendNotificationToPatientFromInstantSwitch = `${apiRoute}/admin/sendNotificationsToPatientFromInstantSwitch`; //? replaced with /is/sendNotificationsToPatient
export const sendNotificationToPatientFromInstantSwitch = `${apiRoute}/is/sendNotificationsToPatient`; // done in backend-upgrade

// instant switch - add internal notes to assessment
// export const addInternalNotesToAssessmentFromInstantSwitch = `${apiRoute}/admin/add/internalnotes`; //? replaced with /is/add/internalnotes
export const addInternalNotesToAssessmentFromInstantSwitch = `${apiRoute}/is/add/internalnotes`; // done in backend-upgrade


// ********** Instant Hush APIs ************

// instant hush - export online assessments
export const exportOnlineAssessmentIHCSVAPI = `${apiRoute}/ih/exportOnlineAssessments`;

//Instant Hush
export const getIHOrderHistoryAPI = `${apiRoute}/ih/orderhistory`;
export const getIHOrderHistoryWithFilterAPI = `${apiRoute}/ih/orderHistoryWithFilter`;


// delete online assessment API - Instant Hush
export const deleteIHOnlineAssessmentAPI = `${apiRoute}/ih/deleteAssessmentOrder`;

// instant hush - change patient contact time
export const updateIHDoctorContactByTimeAPI = `${apiRoute}/ih/onlineassessment/change/contact`;

// instant hush - send notification to patient - SMS and Email - SMS will be the same twilio account from Instant Consult
export const sendNotificationToPatientFromInstantHush = `${apiRoute}/ih/sendNotificationsToPatient`;

// instant hush - add internal notes to assessment
export const addInternalNotesToAssessmentFromInstantHush = `${apiRoute}/ih/add/internalnotes`;

// change status of online assessment for Instant Hush
export const changeIHOnlineAssessmentStatusAPI = `${apiRoute}/ih/changeOnlineAssessmentStatus`;

// toggle isRequire support for Instant Hush
export const toggleIHRequireSupportISAPI = `${apiRoute}/ih/onlineassessment/support/status`;

// instant hush - change consult cost
export const updateConsultCostInstantHushAPI = `${apiRoute}/ih/updateConsultCost`;

// Consult Costs Instant Hush
export const getInstantHushConsultDetailsAPI = `${apiRoute}/admin/getInstantHushConsultDetails`;
export const addInstantHushConsultDetailsAPI = `${apiRoute}/admin/addInstantHushConsultDetail`;
export const editInstantHushConsultDetailsAPI = `${apiRoute}/admin/editInstantHushConsultDetail`;

// Consult Costs Instant Switch Medicinal Cannabis
export const getInstantSwitchConsultDetailsMedicinalCannabisAPI = `${apiRoute}/admin/getInstantSwitchConsultDetailsMedicinalCannabis`;
export const addInstantSwitchConsultDetailsMedicinalCannabisAPI = `${apiRoute}/admin/addInstantSwitchConsultDetailMedicinalCannabis`;
export const editSwitchConsultDetailsMedicinalCannabisAPI = `${apiRoute}/admin/editInstantSwitchConsultDetailMedicinalCannabis`;
export const changeInstantSwitchConsultDetailsSequenceMedicinalCannabisAPI = `${apiRoute}/admin/changeInstantSwitchConsultDetailsSequenceMedicinalCannabis`; // done in backend-upgrade
export const deleteSwitchConsultDetailsMedicinalCannabisAPI = `${apiRoute}/admin/deleteInstantSwitchConsultDetailMedicinalCannabis`;
export const deleteInstantHushConsultDetailsAPI = `${apiRoute}/admin/deleteInstantHushConsultDetail`;
export const changeInstantHushConsultDetailsSequenceAPI = `${apiRoute}/admin/changeInstantHushConsultDetailsSequence`;

// Shifts APIs
export const addDoctorShiftAPI = `${apiRoute}/admin/shift/add`;
export const editDoctorShiftAPI = `${apiRoute}/admin/shift/edit`;
export const getDoctorShiftsAPI = `${apiRoute}/admin/shifts`;
export const deleteDoctorShiftAPI = `${apiRoute}/admin/shift/delete`;
export const doctorAvailableTimesForBookingAPI = `${apiRoute}/admin/availableTime`;

//  initial ticket count
export const getInitialTickitCountApiRoute = `${apiRoute}/admin/ticket/support-action-required-count`;

// add note seperately
export const doctorNotes = `${apiRoute}/admin/ticket/add/note`;
export const editdoctorNotes = `${apiRoute}/admin/ticket/edit/note`;
export const deletedoctorNotes = `${apiRoute}/admin/ticket/delete/note`;
export const doctoreAction = `${apiRoute}/admin/ticket/mark/doctor-action-required`;